export default {
  	currentEditContent: state =>{
  		return state.contentEdit.pageOption
  	}
}